import { downloadFile } from './download'

export type CsvColumn<T> = {
  /** Header label as it appears in the CSV. */
  header: string
  /** Pull the cell value out of a row. */
  value: (row: T) => string | number | boolean | null | undefined
}

const escapeCell = (raw: unknown): string => {
  if (raw == null) return ''
  const s = String(raw)
  if (
    s.includes(',') ||
    s.includes('"') ||
    s.includes('\n') ||
    s.includes('\r')
  ) {
    return `"${s.replace(/"/g, '""')}"`
  }
  return s
}

/**
 * Serialize rows to a CSV string. The first line is a header.
 * Cells with commas, quotes or newlines are wrapped in double quotes per RFC 4180.
 */
export const toCsv = <T>(rows: T[], columns: Array<CsvColumn<T>>): string => {
  const header = columns.map((c) => escapeCell(c.header)).join(',')
  const body = rows
    .map((r) => columns.map((c) => escapeCell(c.value(r))).join(','))
    .join('\r\n')

  return `${header}\r\n${body}`
}

/** Trigger a browser download of `rows` as a CSV file named `filename`. */
export const downloadCsv = <T>(
  filename: string,
  rows: T[],
  columns: Array<CsvColumn<T>>
): void => {
  const csv = toCsv(rows, columns)
  // BOM keeps Excel happy with UTF-8 (otherwise non-ASCII names render as mojibake).
  const blob = new Blob(['﻿', csv], { type: 'text/csv;charset=utf-8' })
  downloadFile(blob, filename.endsWith('.csv') ? filename : `${filename}.csv`)
}
